export interface Category {
  name: string;
  slug: string;
  icon: string;
  description: string;
  videoCount: number;
}

export const categories: Category[] = [
  { name: '全部', slug: 'all', icon: 'ri-apps-line', description: '浏览全部视频内容', videoCount: 12 },
  { name: '纪录片', slug: 'documentary', icon: 'ri-film-line', description: '精选高品质纪录片', videoCount: 2 },
  { name: '教育', slug: 'education', icon: 'ri-book-open-line', description: '学习知识与技能', videoCount: 2 },
  { name: '科技', slug: 'tech', icon: 'ri-cpu-line', description: '前沿科技与创新', videoCount: 2 },
  { name: '美食', slug: 'food', icon: 'ri-restaurant-line', description: '美食制作与鉴赏', videoCount: 1 },
  { name: '健身', slug: 'fitness', icon: 'ri-heart-pulse-line', description: '运动健身教程', videoCount: 1 },
  { name: '音乐', slug: 'music', icon: 'ri-music-line', description: '音乐欣赏与教学', videoCount: 1 },
  { name: '游戏', slug: 'gaming', icon: 'ri-gamepad-line', description: '游戏资讯与攻略', videoCount: 1 },
  { name: '旅游', slug: 'travel', icon: 'ri-plane-line', description: '旅行攻略与见闻', videoCount: 1 },
  { name: '健康', slug: 'health', icon: 'ri-mental-health-line', description: '健康生活指南', videoCount: 1 },
];